export default __webpack_public_path__ + "static/media/track-logo.7f32eeac.png";